import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    user: JSON.parse(localStorage.getItem('user') || 'null'),
    walletSessions: JSON.parse(localStorage.getItem('wallet_sessions') || '{}'),
    drawerVisible: false,
    locale: localStorage.getItem('dapp_locale') || 'zh-CN'
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_USER(state, user) {
      state.user = user
      localStorage.setItem('user', JSON.stringify(user))
      if (user && user.address && state.token) {
        const key = user.address.toLowerCase()
        state.walletSessions = {
          ...state.walletSessions,
          [key]: { token: state.token, user }
        }
        localStorage.setItem('wallet_sessions', JSON.stringify(state.walletSessions))
      }
    },
    UPDATE_BALANCE(state, balance) {
      if (state.user) {
        state.user.balance = balance
        localStorage.setItem('user', JSON.stringify(state.user))
      }
    },
    LOGOUT(state) {
      const currentAddress = state.user && state.user.address ? state.user.address.toLowerCase() : ''
      if (currentAddress && state.walletSessions[currentAddress]) {
        const sessions = { ...state.walletSessions }
        delete sessions[currentAddress]
        state.walletSessions = sessions
        localStorage.setItem('wallet_sessions', JSON.stringify(sessions))
      }
      state.token = ''
      state.user = null
      localStorage.removeItem('token')
      localStorage.removeItem('user')
    },
    CLEAR_ACTIVE_SESSION(state) {
      state.token = ''
      state.user = null
      localStorage.removeItem('token')
      localStorage.removeItem('user')
    },
    SET_DRAWER(state, visible) {
      state.drawerVisible = visible
    },
    SET_LOCALE(state, locale) {
      state.locale = locale === 'en-US' ? 'en-US' : 'zh-CN'
      localStorage.setItem('dapp_locale', state.locale)
    }
  },
  actions: {
    async login({ commit }, { address, signature }) {
      const api = await import('@/api')
      const res = await api.loginBySign(address, signature)
      if (res.code === 0 && res.data && res.data.token) {
        if (!res.data.user || String(res.data.user.address).toLowerCase() !== String(address).toLowerCase()) {
          throw new Error('登录钱包地址与用户地址不一致')
        }
        commit('SET_TOKEN', res.data.token)
        commit('SET_USER', res.data.user)
        return res.data
      } else {
        throw new Error(res.message || '登录失败')
      }
    },
    logout({ commit }) {
      commit('LOGOUT')
    },
    async restoreWalletSession({ commit, state }, address) {
      const key = String(address || '').toLowerCase()
      const session = state.walletSessions[key]
      if (!session || !session.token || !session.user) return null
      commit('SET_TOKEN', session.token)
      commit('SET_USER', session.user)
      return session
    },
    forgetWalletSession({ state }, address) {
      const key = String(address || '').toLowerCase()
      if (!state.walletSessions[key]) return
      const sessions = { ...state.walletSessions }
      delete sessions[key]
      state.walletSessions = sessions
      localStorage.setItem('wallet_sessions', JSON.stringify(sessions))
    },
    toggleDrawer({ commit, state }) {
      commit('SET_DRAWER', !state.drawerVisible)
    },
    openDrawer({ commit }) {
      commit('SET_DRAWER', true)
    },
    closeDrawer({ commit }) {
      commit('SET_DRAWER', false)
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    balance: state => state.user ? state.user.balance : 0,
    earningsBalance: state => state.user ? (state.user.earnings_balance ?? state.user.available_earnings ?? 0) : 0,
    totalEarned: state => state.user ? state.user.total_earned : 0
  }
})
